import React, { useEffect, useState } from 'react';
import {ConfigProvider, Button, Col, Modal, Pagination, Row } from 'antd';
import faIR from 'antd/locale/fa_IR';
import { Delete_FoodListPeriod_Api, GetAll_Paging_FoodListPeriod_Api } from '../../API/FoodListPeriodApi';
import { DeleteOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, ToolOutlined } from '@ant-design/icons';
// ======================================================================
export const AllFoodListPeriodComponent = ({
    setLoading,
    showMessage,
    categoryId,
    categoryTitle,
    version,
    currentPage,
    setCurrentPage,
    onAddClick,
    onEdit,
    onRowDeleted,
    onFoodListWeekClick,
    onBackClick,
}) => {
    // ======================================================================
    const [foodListPeriods, setFoodListPeriods] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [currentPage, version]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_FoodListPeriod_Api({ pageNumber: currentPage, categoryId: categoryId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setFoodListPeriods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        try {
            setLoading(true);
            let data = await Delete_FoodListPeriod_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                    <Button onClick={() => onBackClick()}>
                        <DoubleRightOutlined />
                        بازگشت
                    </Button>
                </Col>
                <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                    <h2 >
                        لیست دوره های برنامه غذای {categoryTitle}
                    </h2>
                </Col>
                <Col xs={10} sm={10} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                    <Button className='btn-primary'
                        onClick={() => onAddClick()} >
                        <PlusOutlined />
                        ایجاد دوره جدید
                    </Button>
                </Col>

            </Row>
            <div className='container'>
                {foodListPeriods.map((foodListPeriod, key) =>
                    <>
                        <Row key={key} className="valueRow" >
                            <Col className="valueColumn textRight" xs={12} sm={12} md={12} lg={15} xl={15}  >
                                {foodListPeriod.title}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={9} xl={9} style={{ textAlign: "left" }}>


                                <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(foodListPeriod.id)}>
                                    <EditOutlined />
                                    ویرایش</Button>


                                <Button className='btn-info' style={{ marginLeft: "2px" }} onClick={() => onFoodListWeekClick(foodListPeriod.id)}>
                                    <ToolOutlined />
                                    برنامه هفتگی
                                </Button>
                                <Button
                                    className='btn-danger'
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از حذف ' + foodListPeriod.title + ' اطمینان دارید؟',
                                            onOk: () => { deleteRow(foodListPeriod.id) },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <DeleteOutlined />
                                    حذف</Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
            <ConfigProvider direction="rtl" locale={faIR}>
                <Pagination current={currentPage}
                    showSizeChanger={false}
                    showQuickJumper={false}
                    align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
            </ConfigProvider>
        </>
    )
}